module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gSUu0f/tc-custom/9781524853044.jpg?1701477017946",
      "alt": "This image is the cover for the book So Who's Counting?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("So Who's Counting?\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Inspiring quotes and advice to help readers see getting older as a time for reinvention and personal growth.")]), _c('br'), _c('br'), _vm._v("“Aging is an extraordinary process where you become the person you should have been.” —David Bowie"), _c('br'), _c('br'), _vm._v(" So long nostalgia, and goodbye resignation! This book of quotes reminds us that growing old isn’t about slowing down and taking it easy—it’s a chance to ask, “What’s next?”  After all, sixty is the new fifty, seventy’s the new sixty, and older is getting younger every day. With fun, forward-looking, and inspiring wisdom, "), _c('i', [_vm._v("So Who’s Counting?")]), _vm._v(" is the ideal gift for baby boomers, Gen Xers or anyone reaching a major age milestone. Instead of cloying sentimentality or the standard sagging-body-part jokes, it strikes the perfect balance of humor, guidance, reflection, bon mots. Quotes are divided into nine sections, such as “As Old as You Feel,” “Laughter: The Best Prescription,” and “Aged to Perfection.” "), _c('i', [_vm._v("So Who’s Counting?")]), _vm._v(" is all about aging with gusto and celebrating what lies ahead."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Erin McHugh, Emily Luchetti\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0